import smartSolveApi from './instances/smartsolve';

export const getReportModel = async (id) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/open', { id });

    return response.data;
  } catch (e) {
    throw new Error(`getReportModel() failed: ${e}`);
  }
};

export const saveReport = async (reportModel = {}) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/save', reportModel);

    return response.data;
  } catch (e) {
    throw new Error(`saveReport() failed: ${e}`);
  }
};

export const exportReport = async (id) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/export', { id });

    return response.data;
  } catch (e) {
    throw new Error(`exportReport() failed: ${e}`);
  }
};

export const deleteReport = async (id) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/delete', { id });

    return response.data;
  } catch (e) {
    throw new Error(`deleteReport() failed: ${e}`);
  }
};

export const getNewReportTemplate = async (modelName, reportName) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/newreporttemplate', {
      modelName,
      reportName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getNewReportTemplate() failed: ${e}`);
  }
};

export const getIsReportNameExists = async (name) => {
  try {
    const response = await smartSolveApi.post('reportdesigner/exists', { name });

    return response.data;
  } catch (e) {
    throw new Error(`getIsReportNameExists() failed: ${e}`);
  }
};

export const getListFilterValues = async (tableName, fieldName) => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/listfiltervalues', {
      tableName,
      fieldName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getListFilterValues() failed: ${e}`);
  }
};

export const getReportModelList = async () => {
  try {
    const response = await smartSolveApi.post('/reportdesigner/reportmodellist');

    return response.data;
  } catch (e) {
    throw new Error(`getReportModelList() failed: ${e}`);
  }
};

export const verifyVirtualEntityExists = async (virtualEntityName = '') => {
  try {
    const response = await smartSolveApi.post('reportdesigner/verifyvirtualentityexists', {
      virtualEntityName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`verifyVirtualEntityExists() failed: ${e}`);
  }
};

export const createVirtualEntity = async (payload = {}) => {
  try {
    const response = await smartSolveApi.post(
      'reportdesigner/createvirtualentityforsavedsearch',
      payload
    );

    return response.data;
  } catch (e) {
    throw new Error(`createVirtualEntity() failed: ${e}`);
  }
};
export const importReportApi = async (file) => {
  try {
    const formData = new FormData();

    formData.append('FileName', file.name);
    formData.append('FileStream', file);

    const response = await smartSolveApi.post('/reportdesigner/import', formData);

    return response;
  } catch (error) {
    throw new Error(`importReport() failed: ${error}`);
  }
};
